(function () {
    'use strict';

    angular
        .module('app.campaign.campaignForm')
        .factory('CampaignFormService', ['$q', '$http', '$rootScope', '$upload',
            function ($q, $http, $rootScope, $upload) {
                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    }

                    $http(req).success(function (data, status) {
                        if (status === 204) {
                            deferred.resolve(data);
                        }

                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                    .error(function (error, status) {
                        error = error || {};
                        error.status = status;
                        deferred.reject(error);
                    });

                    return deferred.promise;
                }

                function getSelectableCampaignTerms(companyId, campaignType, loader) {
                    var url = $rootScope.apiUrl + 'campaign/getSelectableCampaignTerms?companyId=' + companyId + '&campaignType=' + campaignType;
                    return handleRequest(url, 'GET', null, loader);
                }

                function searchMentionByNameAndLanguageId(searchString, languageId, loader) {
                    var url = $rootScope.apiUrl + 'mention/searchMentionByNameAndLanguageId?searchString=' + searchString + '&languageId=' + languageId;
                    return handleRequest(url, 'GET', null, loader);
                }

                function addNewCampaign(params, loader) {
                    var url_addNewCampaign = $rootScope.apiUrl + 'campaign/addNewCampaign';
                    return handleRequest(url_addNewCampaign, 'POST', params, loader);
                }

                function addCustomTerm(params, loader) {
                    var url_addCustomTerm = $rootScope.apiUrl + 'campaign/addCustomTerm';
                    return handleRequest(url_addCustomTerm, 'POST', params, loader);
                }

                function deleteCustomTerm(termId, loader) {
                    var url_deleteCustomTerm = $rootScope.apiUrl + 'campaign/deleteTerm/' + termId;
                    return handleRequest(url_deleteCustomTerm, 'DELETE', null, loader);
                }

                function getMentionIcon(mentionType) {
                    if(mentionType == 1) {
                        return "/images/ico/keyword.gif";
                    } else if(mentionType == 2) {
                        return "/images/ico/url.gif";
                    } else {
                        return "/images/ico/hash.gif";
                    }
                }

                function getCampaign(campaignId, loader) {
                    var url = $rootScope.apiUrl + 'campaign/' + campaignId;
                    return handleRequest(url, 'GET', null, loader);
                }

                function getCampaignTerms(campaignId, loader) {
                    var url = $rootScope.apiUrl + 'campaign/' + campaignId + '/getCampaignTerms';
                    return handleRequest(url, 'GET', null, loader);
                }

                function getCampaignTermsForInfluencer(campaignId, campaignInfluencerId, loader) {
                    var url = $rootScope.apiUrl + 'campaign/' + campaignId + '/getCampaignTerms/' + campaignInfluencerId;
                    return handleRequest(url, 'GET', null, loader);
                }

                function getCampaignInfluencers(campaignId, loader) {
                    var url = $rootScope.apiUrl + 'campaign/' + campaignId + '/getCampaignInfluencers';
                    return handleRequest(url, 'GET', null, loader);
                }

                function getCampaignFiles(campaignId, loader) {
                    var url = $rootScope.apiUrl + 'campaign/' + campaignId + '/getCampaignFiles';
                    return handleRequest(url, 'GET', null, loader);
                }

                function getUploadedFile(fileId, loader) {
                    var url = $rootScope.apiUrl + 'campaign/getUploadedFile/' + fileId;
                    return handleRequest(url, 'GET', null, loader);
                }

                function getUploadedFileUrl(fileId) {
                    var url = $rootScope.apiUrl + 'campaign/getUploadedFile/' + fileId;
                    return url;
                }

                function removeFile(fileId, loader) {
                    var params = { fileId: fileId };
                    var url = $rootScope.apiUrl + 'campaign/removeFile';
                    return handleRequest(url, 'POST', params, loader);
                }

                function uploadFile(file, loader) {
                    return $upload.upload({
                        url: $rootScope.apiUrl + 'campaign/uploadFile',
                        file: file,
                        loader: loader
                    });
                }

                function updateCampaign(params, loader) {
                    var url = $rootScope.apiUrl + 'campaign/updateCampaign';
                    return handleRequest(url, 'POST', params, loader);
                }

                function updateCampaignForInfluencer(params, loader) {
                    var url = $rootScope.apiUrl + 'campaign/updateCampaignForInfluencer';
                    return handleRequest(url, 'POST', params, loader);
                }

                return {
                    getSelectableCampaignTerms: getSelectableCampaignTerms,
                    searchMentionByNameAndLanguageId: searchMentionByNameAndLanguageId,
                    addNewCampaign: addNewCampaign,
                    getMentionIcon: getMentionIcon,
                    addCustomTerm: addCustomTerm,
                    deleteCustomTerm: deleteCustomTerm,
                    getCampaign: getCampaign,
                    getCampaignTerms: getCampaignTerms,
                    getCampaignInfluencers: getCampaignInfluencers,
                    updateCampaign: updateCampaign,
                    getCampaignTermsForInfluencer: getCampaignTermsForInfluencer,
                    updateCampaignForInfluencer: updateCampaignForInfluencer,
                    getCampaignFiles: getCampaignFiles,
                    getUploadedFile: getUploadedFile,
                    getUploadedFileUrl: getUploadedFileUrl,
                    removeFile: removeFile,
                    uploadFile: uploadFile,
                };
            }
        ]);
})();
